import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import api from 'utils/api';
import { setAlert } from 'actions/alerts';
import UIActions from '../actions/uiActions';
export default function adminApi() {
  return _adminApi.apply(this, arguments);
}
function _adminApi() {
  _adminApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window$location,
      hash,
      path,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return api.apply(void 0, _args);
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          if (_context.t0.status === 400 && _context.t0.action === 'refresh') {
            location.reload();
          } else if (_context.t0.status === 401) {
            _window$location = window.location, hash = _window$location.hash, path = _window$location.pathname;
            if (!path.match(/\/login/) && !path.match(/\/forgot/)) {
              // Redirect the user to signin
              window.location.href = "/login?redirectAfterLogin=".concat(path).concat(hash);
            }
          } else if (_context.t0.status === 404) {
            UIActions.closeSpinner();
            setAlert({
              title: _context.t0.statusText
            });
          }
          throw _context.t0;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _adminApi.apply(this, arguments);
}